import makeRequest from 'utils/makeRequest'
import { PUBLIC_ENDPOINTS } from 'config/apiEndpoints'
import IResponseApi from 'models/IResponseApi'
import IDeliveryOrder from 'models/IDeliveryOrder'

export const ordersService = {
  checkoutOrder: async (
    deliveryOrder: IDeliveryOrder
  ): Promise<IResponseApi> => {
    try {
      const response: IResponseApi = await makeRequest(
        'POST',
        PUBLIC_ENDPOINTS.CheckoutOrder,
        JSON.stringify(deliveryOrder),
        'application/json'
      )

      return response
    } catch (error) {
      throw new Error('Checkout order failed')
    }
  },
}
